import React, { useState } from "react";
import { server } from "../config/index";

import Meta from "../components/Meta";
import ContactStyles from "../styles/Contact.module.scss";
import GradientBar from "../components/GradientBar";
import ContactItem from "../components/ContactItem";
import CustomButton from "../components/CustomButton";

import cookie from "react-cookies";

const contact = () => {
  const [subject, setSubject] = useState("default");
  const [last_name, setLastName] = useState("");
  const [first_name, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const [messageSent, setMessageSent] = useState(false);
  const [messageError, setMessageError] = useState(false);
  const [messageLoading, setMessageLoading] = useState(false);

  const sendMessage = () => {
    const axios = require("axios");

    const body = {
      subject: subject,
      name: last_name,
      first_name: first_name,
      from_email: email,
      phone: phone,
      message: message,
    };

    let instance = axios.create({
      headers: {
        post: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRFToken": cookie.load("csrftoken"),
        },
      },
    });

    setMessageLoading(true);
    instance
      .post(server + `/api/v1/public/residens/contact/`, body)
      .then((response) => {
        if (response.status != 200) {
          setMessageLoading(false), setMessageError(true);
          setTimeout(() => {
            setMessageError(false);
          }, 4000);
        } else {
          setMessageLoading(false),
            setMessageSent(true),
            setSubject("default"),
            setLastName(""),
            setFirstName(""),
            setEmail(""),
            setPhone(""),
            setMessage(""),
            setTimeout(() => {
              setMessageSent(false);
            }, 4000);
        }
      })
      .catch((error) => {
        setMessageLoading(false), setMessageError(true);
        setTimeout(() => {
          setMessageError(false);
        }, 4000);
      });
  };

  return (
    <div className={ContactStyles.contactPage}>

      <Meta title={"Résidens - Contact"} />
      <GradientBar />

      <div className={ContactStyles.leftSection}>
        <h1 className={ContactStyles.title}>
          {"Nous Contacter".toUpperCase()}
        </h1>
        <div className={ContactStyles.text}>
          Vous êtes intéressé·e par le projet ? Souhaitez rejoindre l’une de nos
          résidences ou recevoir de plus amples informations ? Nous vous
          répondrons dans les plus brefs délais !
        </div>
        <div className={ContactStyles.contactList}>
          <div className={ContactStyles.contactListItem}>
            <img
              alt="icone flêche "
              src={"/arrow.png"}
              className={ContactStyles.contactListItemIcon}
            />
            <div className={ContactStyles.contactListItemLabel}>
              Par mail via le formulaire
            </div>
          </div>

          <div className={ContactStyles.contactListItem}>
            <img
              alt="icone flêche "
              src={"/arrow.png"}
              className={ContactStyles.contactListItemIcon}
            />
            <div className={ContactStyles.contactListItemLabel}>
              Par courrier : 19, rue du Général Leclerc, 35370
              Argentré-du-Plessis
            </div>
          </div>
        </div>
      </div>
      <div className={ContactStyles.rightSection}>
        <div className={ContactStyles.firstInput}>
          <ContactItem
            label={"Sujet de votre message"}
            placeholder={"Sujet de votre recherche"}
            mandatory
            styleType={"dropdown"}
            onChange={(value) => setSubject(value)}
            value={subject}
          />
        </div>
        <div className={ContactStyles.secondThirdInput}>
          <div className={ContactStyles.secondInput}>
            <ContactItem
              label={"Nom"}
              placeholder={"Nom"}
              mandatory
              styleType={"monoline"}
              type="text"
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          <div className={ContactStyles.thirdInput}>
            <ContactItem
              label={"Prénom"}
              placeholder={"Prénom"}
              mandatory
              styleType={"monoline"}
              type="text"
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
        </div>
        <div className={ContactStyles.fourthInput}>
          <ContactItem
            label={"Email"}
            placeholder={"Email"}
            mandatory
            styleType={"monoline"}
            type="email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className={ContactStyles.fifthInput}>
          <ContactItem
            label={"Téléphone"}
            placeholder={"Téléphone"}
            styleType={"monoline"}
            type="tel"
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
        <div className={ContactStyles.sixthInput}>
          <ContactItem
            label={"Message"}
            placeholder={"Votre message..."}
            mandatory
            styleType={"multiline"}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>
        <div className={ContactStyles.buttonContainer}>
          <CustomButton
            label={
              messageSent
                ? "Envoyé !"
                : messageError
                  ? "Erreur, réessayez"
                  : "Envoyer"
            }
            disabled={
              subject == "default" ||
              last_name == "" ||
              first_name == "" ||
              email === "" ||
              message == ""
            }
            textColor={"#111111"}
            borderColor={"#111111"}
            iconColor={"#111111"}
            backgroundColor={
              messageSent ? "#59bd78" : messageError ? "#e33d54" : "#00000000"
            }
            iconRight={false}
            icon={
              messageSent
                ? "check.png"
                : messageError
                  ? "cross.png"
                  : "arrow.png"
            }
            animatedGradient
            handleClick={() => sendMessage()}
            loading={messageLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default contact;
